import { Paper, Text } from "@mantine/core";
import { GeneralStats } from "./Stats";
import InfoPopover from "./InfoPopover";

interface Props {
    generalStats?: GeneralStats;
}

const GeneralStatsPaperBlocks: React.FC<Props> = ({ generalStats }) => {
    if (!generalStats) {
        return;
    }

    return (
        <div className="flex items-center space-x-8">
            <Paper p="md" withBorder radius="md" w="200px" h="150px">
                <div className="flex items-center flex-col space-y-5">
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Total games
                        </Text>
                        <Text size="xl" mt="-4px" className="font-bold">
                            {generalStats.totalNumAttempts}
                        </Text>
                    </div>
                    <div className="flex items-center space-x-12">
                        <div>
                            <Text className="uppercase" size="xs" c="dimmed">
                                White
                            </Text>
                            <Text size="xl" mt="-4px" className="font-bold">
                                {generalStats.totalWhiteGames}
                            </Text>
                        </div>
                        <div>
                            <Text className="uppercase" size="xs" c="dimmed">
                                Black
                            </Text>
                            <Text size="xl" mt="-4px" className="font-bold">
                                {generalStats.totalBlackGames}
                            </Text>
                        </div>
                    </div>
                </div>
            </Paper>

            <Paper p="md" withBorder radius="md" w="200px" h="150px" className="relative" visibleFrom="xs">
                <div className="flex items-center flex-col space-y-5">
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Total positions
                        </Text>
                        <Text size="xl" mt="-4px" className="font-bold">
                            {generalStats.totalNumPositions}
                        </Text>
                    </div>
                    <div className="flex items-center space-x-12">
                        <div>
                            <Text className="uppercase" size="xs" c="dimmed">
                                White
                            </Text>
                            <Text size="xl" mt="-4px" className="font-bold">
                                {generalStats.numWhitePositions}
                            </Text>
                        </div>
                        <div>
                            <Text className="uppercase" size="xs" c="dimmed">
                                Black
                            </Text>
                            <Text size="xl" mt="-4px" className="font-bold">
                                {generalStats.numBlackPositions}
                            </Text>
                        </div>
                    </div>
                </div>
            </Paper>

            <Paper p="md" withBorder radius="md" w="200px" h="150px" className="relative" visibleFrom="xs">
                <div className="absolute top-1 right-1">
                    <InfoPopover text="Only positions with at least 30 games count" />
                </div>

                <div className="flex items-center flex-col space-y-5">
                    <div>
                        <Text className="uppercase" size="xs" c="dimmed">
                            Average rating
                        </Text>
                        <Text size="xl" mt="-4px" className="font-bold">
                            {isNaN(generalStats.averageRating) || !generalStats.averageRating
                                ? "N/A"
                                : generalStats.averageRating.toFixed(0)}
                        </Text>
                    </div>
                    <div className="flex items-center space-x-12">
                        <div>
                            <Text className="uppercase" size="xs" c="dimmed">
                                White
                            </Text>
                            <Text size="xl" mt="-4px" className="font-bold">
                                {isNaN(generalStats.averageWhiteRating) || !generalStats.averageWhiteRating
                                    ? "N/A"
                                    : generalStats.averageWhiteRating.toFixed(0)}
                            </Text>
                        </div>
                        <div>
                            <Text className="uppercase" size="xs" c="dimmed">
                                Black
                            </Text>
                            <Text size="xl" mt="-4px" className="font-bold">
                                {isNaN(generalStats.averageBlackRating) || !generalStats.averageBlackRating
                                    ? "N/A"
                                    : generalStats.averageBlackRating.toFixed(0)}
                            </Text>
                        </div>
                    </div>
                </div>
            </Paper>
        </div>
    );
};

export default GeneralStatsPaperBlocks;
